import React, { useState } from 'react';

const RegistrationForm = ({ onRegister }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onRegister(email, password, username);
  };

  return (
    <div className="w-full max-w-md mx-auto bg-white rounded-xl shadow-2xl overflow-hidden">
      <div className="bg-gradient-to-r from-green-600 to-green-400 py-6 px-8">
        <h2 className="text-2xl font-bold text-white text-center">Regístrate como Invitado</h2>
      </div>
      <form onSubmit={handleSubmit} className="p-8 space-y-6">
         <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Nombre de Usuario</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all placeholder-gray-400"
            placeholder="Elige un nombre de usuario"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Correo Electrónico</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all placeholder-gray-400"
            placeholder="Ingresa tu correo electrónico"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all placeholder-gray-400"
            placeholder="Crea una contraseña"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-gradient-to-r from-green-600 to-green-400 text-white py-3 px-4 rounded-lg hover:from-green-700 hover:to-green-500 transition-all shadow-md font-semibold"
        >
          Crear cuenta de Invitado
        </button>
      </form>
      <div className="px-8 py-4 bg-gray-50 border-t border-gray-200 text-center">
        <p className="text-xs text-gray-600">Regístrate para acceder a los escaneos compartidos.</p>
      </div>
    </div>
  );
};

export default RegistrationForm;

// DONE